<div class="proyects-container">
  <div class="proyects-title">
    <h2>Portfolio</h2>
    <h3>LASTEST PROJECTS</h3>
  </div>
  <div class="proyects-porfolio">
    <div class="proyects-card"
    *ngFor="let project of projects">
      <app-proyect-card [dataProject]="project"
      ></app-proyect-card>
    </div>
  </div>
</div>
